import React from 'react';

const FormLabel = (props) => {
  const { label = '', parentClassName = '', labelClassName = 'p-medium', isRequired = false } = props || {};
  return (
    <div className={parentClassName}>
      <label className={labelClassName}>
        {label}
        {isRequired ? <span className="alert-star">*</span> : null}
      </label>
    </div>
  );
};

export default FormLabel;
